import contract from './institutional-export.json';
import familyScreen from './familyScreen.json';

export const groups = contract.grupos.filter((g) => g.visivel).sort((a, b) => a.ordem - b.ordem);
export const screens = Object.fromEntries(groups.flatMap((g) => g.telas.map((t) => [t.chave, t])));
screens[familyScreen.chave] = familyScreen;
export const groupPath = (key) => (key === 'home' ? '/' : `/${key}`);
export const detailTypes = {
  solucoes: { screen: 'solucoes-especialidades-lista', name: 'DetalheDaSolucao' },
  insights: { screen: 'insights-publicacoes-lista', name: 'DetalhePublicacao' },
  informacoes: { screen: 'informacoes-lgpd', name: 'DetalheInformacao' },
};
